(ns teamoesterreich.user-mode.landing.landing-content
  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.config :as config]
            [teamoesterreich.store :as store]

            [teamoesterreich.user-mode.landing.actual-news.actual-news :as actual-news]
            [teamoesterreich.user-mode.landing.actual-news.toe-info :as toe-info]
            [teamoesterreich.user-mode.landing.events.event-list :as event-list]


            [teamoesterreich.user-mode.landing.news.news :as news]
            [teamoesterreich.user-mode.widgets.fb-plugin :as fb-plugin]

            ))


(defn get-it []
  (let [!tom-id (r/cursor store/app-state [:actual-user :tom-id])]

    [mui/paper {:style {:margin "-5px 10px 0 0"}}



     (case config/CLIENT
       "tbonn"
       [mui/grid
        {:container   true
         :direction   "row"
         :spacing     0
         :justify     "center"
         :align-items "center"
         :style       {:_backgroundColor "#ffeeff"}
         }



        [mui/grid
         {:container false
          :item      true
          :xl        12
          :xs        12
          :style     {:margin "10px" :minHeight "30px" :padding "30px" :borderRadius "4px"}}

         [event-list/get-it]

         ]


        [mui/grid
         {:container false
          :item      true
          :xl        8
          :xs        12
          :style     {:margin "10px"}
          }
         (if @!tom-id
           [actual-news/get-it]
           [toe-info/get-it]
           )]

        [news/articles-title]
        [news/get-it]
        ]

       "tb"
       [mui/grid
        {:container   true
         :direction   "row"
         :spacing     0
         :justify     "center"
         :align-items "top"
         :style       {:_backgroundColor "#ffeeff" :margin "10px"}
         }
        [mui/grid
         {:container false
          :item      true
          :lg        8
          :xs        12
          :style     {:padding  "0 20px 20px 20px"
                      :maxWidth "600px"
                      :float    "right"}
          }
         (if @!tom-id
           [actual-news/get-it]
           [toe-info/get-it]
           )
         ]

        [mui/grid
         {:container false
          :item      true
          :lg        8
          :xs        12

          }
         [:div {:style {:float   "right"
                        :padding "0 20px 20px 20px"}}
          [fb-plugin/fb-plugin]]

         ]


        [mui/grid
         {:container false
          :item      true
          :md        6
          :xs        12
          :style     {}
          }
         [news/get-it]
         ]

        ]

       ;; TOE
       [mui/grid
        {:container   true
         :direction   "row"
         :spacing     0
         :justify     "center"
         :align-items "center"
         :style       {:_backgroundColor "#ffeeff"}
         }


        [mui/grid
         {:container false
          :item      true
          :xl        12
          :xs        12
          :style     {:margin "10px" :minHeight "30px" :padding "30px" :borderRadius "4px"}}

         [event-list/get-it]

         ]

        [mui/grid
         {:container false
          :item      true
          :xl        6
          :xs        12
          :style     {:margin "10px"}
          }

         (if @!tom-id
           [actual-news/get-it]
           [toe-info/get-it]
           )]



        [news/articles-title]
        [news/get-it]
        ]

       )
     ]))